import { cloneNested } from '@/helpers/helpers'

export default {
  SET_TEAM_DEFINITIONS_DATA(state, payload) {
    state.teamDefinitions = payload
  },
  SET_FREE_TEAM_DEFINITIONS_DATA(state, payload) {
    state.freeTeamDefinitions = payload
  },
  SET_TEAM_DEFINITION_DATA(state, payload) {
    state.teamDefinition = payload
  },
  CLEAR_TEAM_DEFINITION_DATA(state) {
    state.teamDefinition = cloneNested(state.emptyTeamDefinition)
  },
  SET_CHECKLIST_DICTIONARIES_DATA(state, payload) {
    state.checklistDictionaries = payload
  },
  SET_FREE_CHECKLIST_DICTIONARIES_DATA(state, payload) {
    state.freeChecklistDictionaries = payload
  },
  SET_CHECKLIST_DICTIONARY_DATA(state, payload) {
    state.checklistDictionary = payload
  },
  CLEAR_CHECKLIST_DICTIONARY_DATA(state) {
    state.checklistDictionary = cloneNested(state.emptyChecklistDictionary)
  },
}
